import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SR_API_ACTION_ADMIN_ASSIGN_AGENT_TO_TOUR } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';

class SrAdminTourCardSelectTourAgent extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    tourAgents: PropTypes.array.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onSelectTourAgent = (agentUserId) => {
    const { tour, reloadDataTableTour, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_ASSIGN_AGENT_TO_TOUR,
      payload: {
        agentUserId: agentUserId,
        tourId: tour.id,
      },
    }).then(reloadDataTableTour);
  };

  render() {
    const { tour, tourAgents } = this.props;
    const marketId = tour.listings[0].marketId;
    const marketTourAgents = tourAgents.filter(({ staffMarketId }) => {
      return staffMarketId === marketId;
    });

    return (
      <div>
        <select
          onChange={(event) => this._onSelectTourAgent(
            event.target.value ? parseInt(event.target.value, 10) : null
          )}
          value={tour.agentUserId || ''}
          className={classnames('dropdown agentDropdown', { autoAssigned: tour.isAgentAutoAssigned })}
        >
          <option value=''>
            choose agent
          </option>
          {marketTourAgents.map((tourAgent) => (
            <option
              key={tourAgent.id}
              value={tourAgent.id}
            >
              {tourAgent.name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

SrAdminTourCardSelectTourAgent.displayName = 'SrAdminTourCardSelectTourAgent';

export default SrAdminTourCardSelectTourAgent;
